import { render, staticRenderFns } from "./formTab.vue?vue&type=template&id=01e9524c&scoped=true&"
import script from "./formTab.vue?vue&type=script&lang=babel&"
export * from "./formTab.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e9524c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VTab})
